/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IDentalTooth } from 'app/shared/model/dental-tooth.model';
import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { IMedicalHistory } from 'app/shared/model/medical-history.model';
import { IDentalExamAndTreatment } from 'app/shared/model/dental-exam-and-treatment.model';

export interface IDentalMouthItem {
  id?: string;
  available?: boolean | null;
  implant?: boolean | null;
  mobility?: number | null;
  fork1?: number | null;
  bleeding1?: number | null;
  bleeding2?: number | null;
  bleeding3?: number | null;
  bleeding4?: number | null;
  bleeding5?: number | null;
  bleeding6?: number | null;
  plaque1?: number | null;
  plaque2?: number | null;
  plaque3?: number | null;
  plaque4?: number | null;
  plaque5?: number | null;
  plaque6?: number | null;
  gum?: number | null;
  margin1?: string | null;
  margin2?: string | null;
  margin3?: string | null;
  margin4?: string | null;
  margin5?: string | null;
  margin6?: string | null;
  depth1?: string | null;
  depth2?: string | null;
  depth3?: string | null;
  depth4?: string | null;
  depth5?: string | null;
  depth6?: string | null;
  fork2?: number | null;
  fork3?: number | null;
  notes?: string | null;
  treatments?: string | null;
  examinedDate?: number | null;
  active?: boolean | null;
  cursor?: number;
  lastupdated?: number | null;
  microSec?: number | null;
  timestampentry?: number | null;
  tooth?: IDentalTooth;
  patient?: IGlucoUser;
  medicalHistory?: IMedicalHistory | null;
  exam?: IDentalExamAndTreatment | null;
}

export const defaultValue: Readonly<IDentalMouthItem> = {
  available: false,
  implant: false,
  active: false,
};
